import { Entity, Resource, schema } from '@rest-hooks/rest'

export class ScanData extends Entity implements Data.ScanData {
    readonly value: string = ''
    readonly url?: string
    readonly format: Data.BarcodeType = 'PKBarcodeFormatQR'
    pk() {
        return this.value
    }
}